import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs, FreeMode, Mousewheel, Keyboard, Scrollbar } from 'swiper/modules';
import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/thumbs';
// import 'swiper/css/free-mode';

import { Col } from 'reactstrap';

const ImageSlider = ({ apiImages = [] }) => {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    return (
        <>
            {/* Main Image Slider */}
            <Col xl="12" className="product-main">
                <Swiper
                    modules={[Navigation, Thumbs]}
                    navigation
                    thumbs={{ swiper: thumbsSwiper }}
                    spaceBetween={10}
                    slidesPerView={1}
                    className="main-swiper"
                >
                    {apiImages.map((img, i) => (
                        <SwiperSlide key={i}>
                            <img
                                src={img.image_url}
                                alt={`Product ${i}`}
                                className="main-slide-img"
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Col>

            <Col xl="12" className="product-thumbnail">
                <Swiper
                    onSwiper={(e) => {
                        setThumbsSwiper(e);
                    }}
                    spaceBetween={5}
                    slidesPerView={5}
                    direction={'horizontal'}
                    mousewheel={true}
                    speed={300}
                    keyboard={true}
                    modules={[Thumbs, Mousewheel, Keyboard, Scrollbar]}

                    className="thumbs-swiper"
                >
                    {apiImages.map((img, i) => (
                        <SwiperSlide key={i}>
                            <img
                                src={img.image_url}
                                alt={`Thumbnail ${i}`}
                                className="thumb-slide-img"
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Col>
        </>
    );
};

export default ImageSlider;

